import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ManageApprovalSettings = lazy(() =>
  import("@scenes/ManageApprovalSettings").then((module) => ({
    default: module.default.ManageApprovalSettings,
  }))
);

export const approvalWorkflowNRO: NavigationRoutingObject = {
  Component: ManageApprovalSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("manage-approval-settings-pill-menu-option", "Approval Workflow"),
  pageNameForTracking: () => "Approval Workflow",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
